/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SuccessType {
    CUP_WINNER = 'CUP_WINNER',
    CHAMPIONSHIP = 'CHAMPIONSHIP',
}
